module.exports = __webpack_public_path__ + "static/media/logo_th_dark.02f9c0ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/logo_th_dark.svg
// module id = 847
// module chunks = 0